// extracted by mini-css-extract-plugin
export default {"root":"ChangePasswordForm_root__xRp52","emailInput":"ChangePasswordForm_emailInput__smBBj"};